import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
// import Mappings from "./middlewares/mappings";
import { pathOr, startsWith } from "ramda";
import { checkAuthenticated } from "@/shared/utils";

// Create a Router instance.
// -------------------------
// All the routes are to be registered in the routes.js file.
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  linkExactActiveClass: "has-active-child",
});

router.beforeEach(async (to, from, next) => {
  const siteTitle = import.meta.env.VUE_APP_TITLE || "";
  window.document.title =
    to.meta && to.meta.label ? `${siteTitle} | ${to.meta.label}` : siteTitle;

  const modules = import.meta.env.VUE_APP_ACTIVE_MODULES;

  // check if user is authenticated
  if (to.matched.some(({ meta }) => meta.requiresAuth)) {
    const hasLanding = modules.match("landing");
    const isAuthenticated = await checkAuthenticated();
    if (!isAuthenticated) {
      hasLanding ? next("/landing/info") : next("/auth");
      return;
    }
  }

  // Middleware dispatcher
  // to.matched.forEach((route) => {
  //   const middlewares = pathOr([], ["meta", "middlewares"], route);
  //   if (middlewares.length) {
  //     // Loop over all the middlewares of the route
  //     middlewares.forEach((alias) => {
  //       // If a middleware was found
  //       const middleware: any = Mappings[alias];

  //       if (middleware) {
  //         // Call the middleware
  //         return middleware.call(this, to, from, next);
  //       }

  //       return middleware;
  //     });
  //   }
  // });

  // check navigation between old and new projects
  const routeFullPath = pathOr("/", ["fullPath"], to) as string;
  const isRedesignedRoute =
    to.meta?.redesigned === true ||
    to.matched.some((record) => record.meta?.redesigned === true);
  const isVue3EntryRoute =
    routeFullPath === "/" ||
    /^\/(auth|landing|pre-register|dashboard)(\/|$)/.test(routeFullPath);
  const enableLegacyRedirect =
    import.meta.env.VUE_APP_ENABLE_LEGACY_REDIRECT !== "false";

  if (
    enableLegacyRedirect &&
    !isRedesignedRoute &&
    !isVue3EntryRoute &&
    !startsWith("/v2/", routeFullPath) &&
    to.matched.length > 0
  ) {
    const legacyBaseUrl = (
      import.meta.env.VUE_APP_LEGACY_APP_URL ||
      import.meta.env.VUE_APP_BASE_URL ||
      ""
    ).replace(/\/$/, "");
    const url = `${legacyBaseUrl}${routeFullPath}`;
    window.location.href = url;
    return;
  }

  // Continue
  next();
});

export default router;
